/** On unless a build explicitly turns the planner flag off. */
export function plannerAssistantEnabled() {
  const raw = import.meta.env.VITE_PLANNER_ASSISTANT_ENABLED
  if (raw == null || String(raw).trim() === '') return true
  return ['1', 'true', 'yes', 'on'].includes(String(raw).trim().toLowerCase())
}

export function dinnersValueLine({ open = 0, canPlan = false } = {}) {
  if (!canPlan) return ''
  if (open <= 0) return 'Plan next week from what\u2019s already in your pantry.'
  return ''
}

/** Pass 1: the pill focuses the existing planner until the overlay ships. */
export function focusPlannerAssistant() {
  const panel = document.getElementById('planner-assistant-panel')
  const input = document.getElementById('planner-assistant-input')
  panel?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  input?.focus()
}
